import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import CalendarHero from './components/CalendarHero';
import TournamentBrowser from './components/TournamentBrowser';
import ListEventForm from './components/ListEventForm';

export default function Calendar() {
  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Header />
      <main>
        <CalendarHero />
        <TournamentBrowser />
        <ListEventForm />
      </main>
      <Footer />
    </div>
  );
}